import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import NoticeboardButton from "../../components/shared/NoticeboardButton";
import { COURSE_PATH, LESSONS, lessonPath } from "../../domain/help/course";
import { useCourseProgress } from "../../hooks/useCourseProgress";
import { routerLinkProps } from "./routerLinkProps";

/** Points Video Tutorials at the course: take it, or carry on. Gone once every written lesson is done. */
const FundamentalsBanner: React.FC = () => {
  const theme = useTheme();
  const { doneCount, nextUp, progressReady } = useCourseProgress();
  if (!progressReady || !nextUp) return null;
  const started = doneCount > 0;

  return (
    <Box
      component="aside"
      aria-label="Noticeboard Fundamentals"
      sx={{
        mt: { xs: 2, md: 0 },
        mb: 3,
        borderRadius: { xs: 2, md: 3 },
        px: { xs: 2, md: 3 },
        py: { xs: 2, md: 1.75 },
        border: "1px solid",
        borderColor: alpha(theme.palette.primary.main, 0.14),
        background: `linear-gradient(135deg, ${theme.palette.gradients.heroSurface[0]} 0%, ${theme.palette.gradients.heroSurface[1]} 100%)`,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        gap: { xs: 1.5, sm: 2 },
        textAlign: { xs: "center", sm: "left" },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
        <Box aria-hidden sx={{ color: "primary.main", fontSize: "1.2rem", lineHeight: 1 }}>
          ✦
        </Box>
        <Typography sx={{ fontSize: { xs: "1rem", md: "1.05rem" }, color: "text.primary" }}>
          {started ? (
            <>
              Noticeboard Fundamentals:{" "}
              <Box component="span" sx={{ color: "text.secondary" }}>
                {doneCount} of {LESSONS.length} done
              </Box>
            </>
          ) : (
            "New here?"
          )}
        </Typography>
      </Box>{" "}
      <NoticeboardButton
        variant="primary"
        {...routerLinkProps(started ? lessonPath(nextUp) : COURSE_PATH)}
        sx={{ borderRadius: 999, px: 3, py: 0.75, fontWeight: 600, flexShrink: 0 }}
      >
        {started ? `Continue lesson ${nextUp.number}` : "Take Noticeboard Fundamentals"}
      </NoticeboardButton>
    </Box>
  );
};

export default FundamentalsBanner;
